import { render } from "./InfoProprietario.vue?vue&type=template&id=5079cc9e"
import script from "./InfoProprietario.vue?vue&type=script&lang=js"
export * from "./InfoProprietario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__